import React from 'react';
import { useTutorialSafe } from '@/app/contexts/TutorialContext';
import { getTutorialModules } from '@/app/utils/tutorialStepsSimplified';
import type { TutorialModule as TutorialModuleType } from '@/app/types/tutorial';

export function TutorialProgress() {
  const tutorial = useTutorialSafe();

  // Return null if tutorial context not available
  if (!tutorial) {
    return null;
  }

  const { state } = tutorial;

  if (!state.isActive || !state.progress.currentModule) {
    return null;
  }

  const modules = getTutorialModules();
  const currentModule = modules.find(m => m.id === state.progress.currentModule);

  if (!currentModule) {
    return null;
  }

  const totalSteps = currentModule.steps.length;
  const currentStepNumber = state.progress.currentStepIndex + 1;
  const progress = (currentStepNumber / totalSteps) * 100;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 pointer-events-auto rounded-full shadow-lg px-6 py-3"
      style={{
        backgroundColor: 'var(--md-surface)',
        border: '1px solid var(--md-outline)',
        zIndex: 10002,
      }}
    >
      <div className="flex items-center gap-4">
        {/* Module name */}
        <div className="text-sm font-medium" style={{ color: 'var(--md-on-surface)' }}>
          {currentModule.name}
        </div>

        {/* Progress bar */}
        <div className="w-48 h-2 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--md-surface-container-high)' }}>
          <div
            className="h-full transition-all duration-300 rounded-full"
            style={{
              width: `${progress}%`,
              backgroundColor: 'var(--md-primary)',
            }}
          />
        </div>

        {/* Step counter */}
        <div className="text-sm font-medium" style={{ color: 'var(--md-on-surface-variant)' }}>
          {currentStepNumber} / {totalSteps}
        </div>
      </div>
    </div>
  );
}

// Add default export for better compatibility
export default TutorialProgress;